import React from "react";
import { useNavigate } from "react-router-dom";

const CandidateTable = ({ finalData, groupId }) => {
  const navigate = useNavigate();
  const handleView = (id) => {
    navigate("/candidate-detail", { state: { group: groupId, id: id } });
  };
  return (
    <>
      <div className="table-responsive mt-3">
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th scope="col">User Id</th>
              <th scope="col">Name Of Applicant</th>
              <th scope="col">Father Name</th>
              <th scope="col">Mother Name</th>
              <th scope="col">Application status</th>
              <th scope="col">Verification status</th>
              <th scope="col">Category</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {finalData.results?.map((data, index) => (
              <tr key={index}>
                <td>{data.candidate.transaction_id}</td>
                <td>{data.candidate.name}</td>
                <td>{data.candidate.father_name}</td>
                <td>{data.candidate.mother_name}</td>
                <td>{data.final_status}</td>
                <td>{data.verification_status}</td>
                <td>{data.candidate.caste}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      handleView(data.id);
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CandidateTable;
